import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

export const ModalContent = styled.div`
  padding: 1.5rem;
  max-width: 50rem;
  max-height: 80vh;
  overflow-y: auto;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StatusBadge = styled.span<{ color: string }>`
  display: inline-block;
  padding: 0.375rem 1rem;
  border-radius: 0.25rem;
  background-color: ${({ color }) => color};
  color: ${Theme.colors.WHITE};
  font-size: 0.9375rem;
  font-weight: 500;
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  background-color: ${Theme.colors.G_6};
  border-radius: 0.5rem;
`;

export const InfoRow = styled.div`
  display: flex;
  gap: 1rem;
`;

export const InfoLabel = styled.span`
  font-size: 0.9375rem;
  font-weight: 600;
  color: ${Theme.colors.BLACK};
  min-width: 6rem;
`;

export const InfoValue = styled.span`
  font-size: 0.9375rem;
  color: ${Theme.colors.BLACK};
`;

export const WorkersSection = styled.div`
  padding: 1rem;
  background-color: ${Theme.colors.G_6};
  border-radius: 0.5rem;
`;

export const WorkersTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.75rem;
`;

export const WorkersThead = styled.thead`
  background-color: ${Theme.colors.WHITE};
  border-bottom: 0.125rem solid ${Theme.colors.G_3};
`;

export const WorkersTr = styled.tr`
  border-bottom: 0.0625rem solid ${Theme.colors.G_3};
`;

export const WorkersTh = styled.th`
  padding: 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: ${Theme.colors.BLACK};
  text-align: center;
`;

export const WorkersTbody = styled.tbody`
  background-color: ${Theme.colors.WHITE};
`;

export const WorkersTd = styled.td`
  padding: 0.75rem;
  font-size: 0.875rem;
  color: ${Theme.colors.BLACK};
  text-align: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
`;

